////////////////////////////////////////////////////////////////////////////////
// Copyright 2019 Federated Wireless.
//
// GOVERNMENT PURPOSE RIGHTS
//
// Contractor Name:    Federated Wireless
// Contractor Address: 3865 Wilson Blvd, Arlington, VA 22203
//
// The Government's rights to use, modify, reproduce, release, perform, display,
// or disclose this software are restricted by paragraph (b)(2) of the Rights in
// Noncommercial Computer Software and Noncommercial Computer Software
// Documentation clause contained in the 7013 Clause. Any reproduction of the
// software or portions thereof marked with this legend must also reproduce the
// markings.
// This source code delivery is exclusively for Government Purposes pertaining
// to this program; no commercial use. The Computer Software Configuration
// Items were delivered for only the purposes spelled out by the contract
// delivered under.
//
// Export Warning - The technical data in this document (or file) is
// controlled for export under the International Traffic in Arms Regulations
// (ITAR), 22CFR 120-130.  Violations of these export laws may be subject to
// fines and penalties under the Arms Export Control Act (22 U.S.C. 2778).
//
////////////////////////////////////////////////////////////////////////////////
//
// Security Classification: UNCLASSIFIED
//
////////////////////////////////////////////////////////////////////////////////


import React, { Component } from 'react'
import ProfileForm from './ProfileForm'

import {Redirect } from "react-router-dom";
import axios from 'axios'



class ProfileFormWrapper extends Component {
  constructor(props) {
    super(props)
    this.state = {
        submitted: false,
        page:1
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.previousPage = this.previousPage.bind(this)
  }


  previousPage= () =>{
    if (this.state.page > 1){
        this.setState({page:this.state.page-1})
    }
}

  handleSubmit = (values) =>{
    console.log(values)
    if (this.state.page < 4){
        this.setState({page:this.state.page+1})
        return
    }
    const config = { headers: { 'content-type': 'application/json' } }
    let URL = `${this.props.api_url}/configureprofile`
    axios.post(URL, {"user_info":values, "user_id":localStorage.getItem("user_id")}, config)
      .then(response =>{
        console.log(response)
        if (response.data.error){
          this.setState({ 
            failed: true,
            error_message:response.data.message
          })
        }
        else {
          this.setState({submitted: true})
        }
        })
      .catch(
        function(error) {
          console.log(
          error
        )
      })
  }

  componentWillMount() {
    const config = { headers: { 'content-type': 'application/json' } }
    let URL = `${this.props.api_url}/configureprofile`
    axios.put(URL, {"user_id":localStorage.getItem("user_id")}, config)
      .then(response =>{
        this.setState({
            initialValues: {initialValues: response.data.user_info}
        })
        })
      .catch(
        function(error) {
          console.log(
          error
        )
      })
}

  render() {
    const { submitted } = this.state

    if (submitted===true){
      return <Redirect to='/ru/list' />
    }
    return (
          <React.Fragment>
          <ProfileForm {...this.state.initialValues} onSubmit={this.handleSubmit} previousPage={this.previousPage} page={this.state.page}/>
          </React.Fragment>
    )
}
}

export default ProfileFormWrapper